import { GET_BOM_REQUEST, GET_BOM_SUCCESS, GET_BOM_FAILURE } from "./bomTypes";
import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;

const getBomReportsRequest = () => {
  return {
    type: GET_BOM_REQUEST,
  };
};

const getBomReportsSuccess = (payload) => {
  return {
    type: GET_BOM_SUCCESS,
    payload: payload,
  };
};

const getBomReportsFailure = (error) => {
  return {
    type: GET_BOM_FAILURE,
    payload: error,
  };
};

const getBomReports = (fgCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getBomReportsRequest());
    let url = `${baseUrl}/reports/bom?fg_code=${fgCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getBomReportsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getBomReportsFailure(err.response));
      });
  };
};

export { getBomReports };
